import {
  Component,
  Host,
  h,
  Prop,
  State,
  Event,
  EventEmitter
} from "@stencil/core";

import { MercuryBundles } from "@genexus/mercury";

const CSS_BUNDLES: MercuryBundles = [
  "resets/box-sizing",
  "components/button",
  "utils/typography"
];
@Component({
  tag: "gx-ide-loader",
  styleUrl: "ide-loader.scss",
  shadow: true
})
export class IdeLoader {
  #timeoutReference: ReturnType<typeof setTimeout>;

  /**
   * shows the '.loader-wrapper'
   */
  @State() showWrapper = true;

  /**
   * The time the loader will await before abort.
   */
  @Prop() readonly abortTime: number = 5 * 60 * 1000; // 5 minutes

  /**
   * The cancel callback
   */
  @Prop() readonly cancelCallback: IdeLoaderCancelCallback;

  /**
   * The cancel button label (optional)
   */
  @Prop() readonly cancelLabel: string;

  /**
   * The loader description (optional)
   */
  @Prop() readonly description: string;

  /**
   * The loader title (optional)
   */
  @Prop() readonly loaderTitle: string;

  /**
   * It shows the loader
   */
  @Prop({ mutable: true }) show = false;

  /**
   * This event is emitted when "show" is false.
   */
  @Event() loaderFinished: EventEmitter<void>;

  #cancelProcess = (): void => {
    if (this.cancelCallback) {
      this.cancelCallback();
    }
    clearTimeout(this.#timeoutReference);
    this.show = false;
  };

  #renderCancelButton = (): HTMLButtonElement | null =>
    this.cancelLabel && (
      <div>
        <button
          class="button-secondary loader__cancel-button"
          type="button"
          onClick={this.#cancelProcess}
        >
          {this.cancelLabel}
        </button>
      </div>
    );

  #renderDescription = (): HTMLParagraphElement | null =>
    this.description && <p class="body-regular-italic-s">{this.description}</p>;

  #renderTitle = (): HTMLParagraphElement | null =>
    this.loaderTitle && <p class="body-regular-l">{this.loaderTitle}</p>;

  render() {
    return (
      <Host>
        <ch-theme model={CSS_BUNDLES}></ch-theme>
        {this.show && (
          <div
            class={{
              [`loader__wrapper`]: true,
              "loader__wrapper--visible": this.showWrapper
            }}
            part="loader-wrapper"
            popover=""
          >
            <div class="loader__spinner"></div>
            <div
              class={{
                "loader__content-wrapper": true,
                "loader__content-wrapper--hidden":
                  !this.description && !this.loaderTitle && !this.cancelLabel
              }}
            >
              {this.#renderTitle()}
              {this.#renderDescription()}
              {this.#renderCancelButton()}
            </div>
          </div>
        )}
      </Host>
    );
  }
}

export type IdeLoaderCancelCallback = () => void;
